import { cn } from "@/lib/utils";
import { TrashIcon as HeroTrashIcon } from "@heroicons/react/24/outline";
import { forwardRef, type ComponentProps } from "react";

export const DestructiveTrashIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof HeroTrashIcon>
>(({ className, ...props }, ref) => (
  <HeroTrashIcon
    ref={ref}
    className={cn(className, "text-red-600 dark:text-red-400")}
    {...props}
  />
));

DestructiveTrashIcon.displayName = "DestructiveTrashIcon";
